"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _FormattedGraphqlError = require("./FormattedGraphqlError");
Object.keys(_FormattedGraphqlError).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FormattedGraphqlError[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _FormattedGraphqlError[key];
        }
    });
});
var _FormattedAxiosError = require("./FormattedAxiosError");
Object.keys(_FormattedAxiosError).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FormattedAxiosError[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _FormattedAxiosError[key];
        }
    });
}); //# sourceMappingURL=index.js.map
